import React from 'react';
var ReactionPanelContext = /*#__PURE__*/React.createContext({
  disabled: true,
  setDisabled: function setDisabled() {
    return null;
  },
  activeId: false,
  setActiveId: function setActiveId() {
    return null;
  }
});
export default ReactionPanelContext;